let beta = false

export function setBrandStage(stage: string | undefined) {
  beta = stage === 'beta'
}

export function isBrandBeta() {
  return beta
}
